/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import '../style/navbar.css'

const Navbar = () => {
    return (
        <>
            <section style={{ boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)', backgroundColor: 'white', top: '0', zIndex: '1', position: 'sticky', opacity: '.95' }}>
                <div className='container'>
                    <nav className="navbar navbar-expand-lg navbar-light" >
                        <div className="container-fluid">
                            <a className="navbar-brand" href="/"><p id='navLogo' style={{ fontFamily: 'revert', marginBottom: '0px' }}>UMANG RATANI</p></a>
                            <button className="navbar-toggler" id='navC' type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                                <span className="navbar-toggler-icon"></span>
                            </button>
                            <div className="collapse navbar-collapse" id="navbarSupportedContent">
                                <div className='container'></div>
                                <div className="form-inline my-2 my-lg-0">
                                    <ul className="navbar-nav me-auto mb-2 mb-lg-0 ml-auto" style={{ fontSize: "15px", fontWeight: "500" }}>
                                        <li className="nav-item">
                                            <a className="nav-link active" aria-current="page" href="/" >Home</a>
                                        </li>
                                        <li className="nav-item active">
                                            <a className="nav-link" href="/MyStory" >My&nbsp;Story<span className="sr-only"></span></a>
                                        </li>
                                        <li className="nav-item active">
                                            <a className="nav-link" href="/Speaking" >Speaking<span className="sr-only"></span></a>
                                        </li>
                                        <li className="nav-item active">
                                            <a className="nav-link" href="/OurCourses" ><span className="sr-only">Our&nbsp;Courses</span></a>
                                        </li>
                                        <li className="nav-item active">
                                            <a className="nav-link" href="/CaseStudy" ><span className="sr-only">Case&nbsp;Study</span></a>
                                        </li>
                                        <li className="nav-item active dropdown">
                                            <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                Resources
                                            </a>
                                            <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                                                <li><a className="dropdown-item" href="/OurCourse/MyVideos">MY VIDEOS</a></li>
                                                <li><a className="dropdown-item" href="/OurCourse/MyPoadcast">MY PODCASTS</a></li>
                                                <li><hr className="dropdown-divider" /></li>
                                                <li><a className="dropdown-item" href="/OurCourse/FreeResource">FREE RESOURCES</a></li>
                                            </ul>
                                        </li>
                                        <li className="nav-item active">
                                            <a className="nav-link" href="/ContactUs">Contact&nbsp;Us<span className="sr-only"></span></a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </nav>
                </div>
            </section>
        </>
    )
}

export default Navbar
